import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next"
import './index.scss'
import { UploadButton } from '../../UploadOverlay/uploadButton'
import { ThirdPartyLibraryState } from '../../ImageLibrary/types/ThirdPartyLibrary';
import { setForceUploadOverlayOpen } from '../../redux/actions/product';
import { closeImageLibraries, setImageLibraryImageConsumed } from '../redux/actions';

export const UploadTile = ({ fabricSize, partId, wizardScreen }: any) => {

    const { t } = useTranslation()
    const currentImage = useSelector((state: any) => state.currentImg);
    const forceUploadOverlayOpen = useSelector((state: any) => state.forceUploadOverlayOpen);
    const mediaLibTitle = useSelector((state: any) => state.mediaLibTitle);
    const { id: categoryId, isOpenToUse } = useSelector(({ thirdPartyLibrary }: { thirdPartyLibrary: ThirdPartyLibraryState }) => thirdPartyLibrary.rootCategory) || {};

    const [showUploadBanner, setUploadBannerVisible] = useState(true);

    const dispatch = useDispatch();

    // useEffect(()=>{
    //     dispatch(setForceUploadOverlayOpen(false))
    //     setUploadBannerVisible(false);
    // },[])

    const handleImageSelection = useCallback(() => {
        // dispatch(setForceUploadOverlayOpen(false))
        // setUploadBannerVisible(false);
        dispatch(setImageLibraryImageConsumed())
        dispatch(closeImageLibraries(null));
        wizardScreen && wizardScreen()
    }, [])

    return (
        <div className='e-card'>
            <UploadButton onImageSelected={handleImageSelection}
                fabricSize={fabricSize}
                partId={partId}
                isTileUpload={true} />
        </div>
    )
}
